const footer = {
  footer: {
    imageTitle: 'Visita el sitio web de Enphase Energy.',
    privacy: 'Privacidad',
    terms: 'Términos',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Todos los derechos reservados.',
    language: 'Idioma',
    production_ct: {
      verify_ct: "Verificar transformador de corriente",
      checlist_nodata: "No se dispone de datos suficientes del contador para realizar esta comprobación",
      production_meter_verification: "Verificación del Medidor de producción",
      serial_no: "Número de serie",
      polarity_check: "Verificación de Polaridad",
      polarity_check_failed: "Verificación de polaridad fallida",
      ct_missing_branch_check: "Verificando si el transformador de corriente tiene circuitos derivados que falten",
      polarity_check_passed: "Comprobación de polaridad superada",
      ct_no_missing_branch_circuit: "Al transformador de corriente no le faltan circuitos derivados",
      incorrect_direction_or_phase_message: "La dirección o la fase del transformador de corriente de producción pueden ser incorrectas",
      hide_details: "Ocultar detalles",
      check_try_again: "Compruebe lo siguiente y vuelva a intentarlo",
      pv_on_for_5_min: "Asegúrese de que el circuito fotovoltaico esté encendido y de que lo ha estado durante al menos 5 minutos.",
      l1_wires_production_ct_message: "Compruebe que solo los cables L1 pasan a través del transformador de corriente de producción y que el flujo de producción está en la dirección de la flecha del transformador de corriente, desde el generador fotovoltaico al disyuntor.",
      blue_white_wires_position_message: "Asegúrese de que los cables azul y blanco están conectados a las posiciones correctas del bloque de terminales del Gateway",
      wires_include_pv_generation_not_load_storage: "Asegúrese de que los cables que pasan por el transformador de corriente de producción solo incluyen generación fotovoltaica (no cargas ni almacenamiento).",
      l1_a_correct_phase_message: "Asegúrese de que la fase correcta, es decir, L1(a), pasa por el transformador de corriente de producción.",
      l1_phase_consistency_check_message: "Compruebe la consistencia de la fase L1 con un medidor digital y asegúrese de que la fase L1 de los circuitos fotovoltaicos y la fase L1 del Gateway coinciden.",
      missing_branch_warning: "Es posible que falten circuitos derivados en el transformador de corriente de producción.",
      test_only_valid_for_sunshine_hours: "Esta prueba solo es válida para las horas de sol",
      reading_lower_than_expected: "Las lecturas de producción son más bajas de lo esperado. Compruebe lo siguiente, luego pulse y vuelva a intentarlo",
      wires_include_all_pv_generation: "Asegúrese de que el cable que pasa por el transformador de corriente de producción incluye todos los circuitos de generación fotovoltaicos.",
      branch_circuit_reverse_check: "Asegúrese de que ninguno de los circuitos derivados pase por el transformador de corriente en sentido inverso.",
      storage_load_circuits_through_production_ct: "Asegúrese de que haya circuitos de almacenamiento o carga que pasen por el transformador de corriente de producción.",
      show_details: "Mostrar detalles",
      verify_ct_not_supported_for_device: "Comprobación de medidores no es posible en este dispositivo",
      verify_ct_timeStamp: "Comprobado en",
      verify_ct_systemID: "identificación del sistema",
      prodct_reversepolarity_text: "La dirección o la fase del transformador de corriente de producción pueden ser incorrectas",
      prodct_reverse_polarity_btn: "Polaridad inversa",
      verify_ct_timeout: "Tiempo de espera agotado. Inténtelo de nuevo"

    }
  }
};

export default footer;
